// Number of days with snow

// 0: year
// 1: number of days with snow cover
// 2: running mean
// 3: round

export default [
	// [1950, 98, 113.7, 114],
	// [1951, 147, 113.9, 114],
	// [1952, 94, 114.3, 114],
	// [1953, 110, 114.7, 115],
	// [1954, 103, 115.1, 115],
	// [1955, 126, 115.4, 115],
	// [1956, 137, 115.2, 115],
	// [1957, 109, 114.6, 115],
	// [1958, 119, 113.8, 114],
	// [1959, 108, 113, 113],
	[1960, 104, 112.7, 113],
	[1961, 92, 113.1, 113],
	[1962, 120, 114.3, 114],
	[1963, 136, 116.1, 116],
	[1964, 95, 118.5, 119],
	[1965, 112, 121, 121],
	[1966, 156, 123.2, 123],
	[1967, 112, 124.8, 125],
	[1968, 115, 125.1, 125],
	[1969, 150, 123.9, 124],
	[1970, 160, 120.9, 121],
	[1971, 112, 116.7, 117],
	[1972, 124, 112, 112],
	[1973, 67, 108.1, 108],
	[1974, 88, 105.9, 106],
	[1975, 81, 105.9, 106],
	[1976, 93, 108, 108],
	[1977, 137, 111.4, 111],
	[1978, 117, 115.2, 115],
	[1979, 131, 118.7, 119],
	[1980, 122, 121.4, 121],
	[1981, 127, 123.3, 123],
	[1982, 140, 124.4, 124],
	[1983, 96, 124.9, 125],
	[1984, 125, 124.7, 125],
	[1985, 137, 123.4, 123],
	[1986, 151, 120.5, 121],
	[1987, 128, 116.2, 116],
	[1988, 127, 110.7, 111],
	[1989, 91, 105, 105],
	[1990, 70, 100.3, 100],
	[1991, 87, 97.4, 97],
	[1992, 64, 96.6, 97],
	[1993, 87, 97.7, 98],
	[1994, 124, 99.7, 100],
	[1995, 105, 101.7, 102],
	[1996, 139, 102.9, 103],
	[1997, 92, 103, 103],
	[1998, 94, 102.3, 102],
	[1999, 123, 101.2, 101],
	[2000, 80, 100.3, 100],
	[2001, 80, 100.1, 100],
	[2002, 92, 100.3, 100],
	[2003, 120, 100.8, 101],
	[2004, 117, 101.2, 101],
	[2005, 92, 101.2, 101],
	[2006, 130, 100.9, 101],
	[2007, 78, 100.6, 101],
	[2008, 68, 100.3, 100],
	[2009, 103, 100.1, 100],
	[2010, 122, 99.4, 99],
	[2011, 137, 98, 98],
	[2012, 66, 95.6, 96],
	[2013, 128, 92.6, 93],
	[2014, 62, 89.3, 89],
	[2015, 72, 86.4, 86],
	[2016, 73, 83.9, 84],
	[2017, 85, 82, 82],
	[2018, 109, 80.4, 80],
	[2019, 86, 78.9, 79],
	[2020, 40, 77.7, 78],
	[2021, 72, 76.6, 77],
	[2022, 87, 75.9, 76],
];